import { SLACK_MARKETPLACE_URL } from '~/modules/config';
import { JAPANESE_LANGUAGE_CODE } from '~/modules/utilities/language_utils';
import { buildUrl } from '~/modules/utilities/route_utils';

export interface SlackMarketplaceLink {
    url: string;
    target: string;
    rel?: string;
}

interface SlackMarketplaceLinkInput {
    domain: string | undefined;
    language: string | undefined;
    oafId: string | undefined;
    slug: string | undefined;
}

export const hasUsableSlackMarketplaceSlug = (slug: string | undefined): slug is string => Boolean(slug?.trim());

export const getSlackUtmSource = (domain: string | undefined, language: string | undefined): string => {
    const isJapanese = language === JAPANESE_LANGUAGE_CODE;
    if (domain === 'agentexchange') {
        return isJapanese ? 'agentexchangejp' : 'agentexchange';
    }
    if (domain === 'appexchange-jp') {
        return 'appexchangejp';
    }
    return 'appexchange';
};

export const buildSlackMarketplaceLink = ({
    domain,
    language,
    oafId,
    slug,
}: SlackMarketplaceLinkInput): SlackMarketplaceLink => {
    if (!hasUsableSlackMarketplaceSlug(slug)) {
        return { url: '', target: '_self' };
    }

    const baseUrl = `${SLACK_MARKETPLACE_URL}/${encodeURIComponent(slug.trim())}`;
    return {
        url: buildUrl(baseUrl, {
            utm_source: getSlackUtmSource(domain, language),
            utm_medium: 'search_result',
            utm_campaign: 'slack_search',
            utm_content: oafId || 'default',
        }),
        target: '_blank',
        rel: 'noopener noreferrer',
    };
};
